export enum Domain {
    AIRPORT = 'location/airport',
    ACCOUNT = 'account',
    COMPANY = 'company',
}

export type ValueMappingRequest = {
    domain: Domain,
    data: string[]
}
export type ValueMappingResponse = {
    id: number,
    label: string
}
